import React from "react";
import { Role } from "@/api/roles";
import {
  removeApplicationCustomerUserRoles,
  User,
  ApplicationCustomerUserRoles,
} from "@/api/users";
import { DataGrid, DataGridColumn } from "@/ui-controls/DataGrid";
import { Link } from "react-router-dom";
import { Application } from "@/api/applications";
import { Customer } from "@/api/customers";
import MoreActionsButton from "@/ui-controls/MoreActionsButton";

interface Props {
  application: Application;
  customer: Customer;
  user: User;
  roleList: Role[];
  onRemoveRoles?: (roleIds: number[]) => any;
}

const AppCustomerUserRoleDetailList = (props: Props) => {
  const countBadgeStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 32,
    height: 28,
    padding: "0 10px",
    borderRadius: 14,
    backgroundColor: "#f3f2f1",
    color: "#323130",
    fontWeight: 600,
    textDecoration: "none",
  };

  const removeAppCustomerUserRole = (role: Role) => {
    removeApplicationCustomerUserRoles({
      AppId: props.application.Id,
      CustomerId: props.customer.Id,
      UserId: props.user.Id,
      RoleIds: [role.Id],
    } as ApplicationCustomerUserRoles).then(
      (_) => {
        if (props.onRemoveRoles) props.onRemoveRoles([role.Id]);
      },
      (error) => {
        handleError(error);
      }
    );
  };

  const buildPath = (item: Role) => {
    return `/applications/${props.application.Id}/customers/${props.customer.Id}/users/${props.user.Id}/roles/${item.Id}/privileges`;
  };

  const handleError = (error: Error) => {
    // Error handling would go here in real app
  };

  const columns: DataGridColumn[] = [
    {
      key: "id",
      name: "Id",
      fieldName: "Id",
      minWidth: 50,
      maxWidth: 60,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "name",
      name: "Name",
      fieldName: "Name",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "Description",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "weight",
      name: "Weight",
      fieldName: "Weight",
      minWidth: 150,
      maxWidth: 250,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
    },
    {
      key: "NoPrivileges",
      name: "Privileges",
      fieldName: "PrivilegesCount",
      minWidth: 70,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      isPadded: true,
      onRender: (item: Role) => (
        <Link to={buildPath(item)} style={countBadgeStyle}>
          {item.PrivilegesCount}
        </Link>
      ),
    },
    {
      key: "Actions",
      name: "",
      minWidth: 50,
      maxWidth: 70,
      onRender: (item: Role) => (
        <MoreActionsButton
          menu={[
            {
              key: "remove",
              text: "Remove role from user",
              iconProps: { iconName: "Cancel" },
              onClick: () => {
                removeAppCustomerUserRole(item);
              },
            },
            // {
            //   key: "deactivate",
            //   text: "Deactivate customer",
            //   iconProps: { iconName: "Delete" },
            //   onClick: () => {
            //     setMenuActionType(MenuActionType.DEACTIVATE_CUSTOMER);
            //     setSelectedCustomer(item);
            //   },
            // },
            // {
            //   key: "addSection",
            //   text: "Add",
            //   iconProps: { iconName: "Add" },
            //   subMenuProps: {
            //     items: [
            //       {
            //         key: "addUser",
            //         text: "User",
            //         title: "Add application user",
            //         onClick: () => {
            //           setMenuActionType(MenuActionType.ADD_USER);
            //           setSelectedCustomer(item);
            //         },
            //       },
            //       {
            //         key: "restrictPrivileges",
            //         text: "Restrict Privileges",
            //         title: "Restrict customer privileges",
            //         onClick: () => {
            //           setMenuActionType(MenuActionType.RESTRICT_PRIVILEGES);
            //           setSelectedCustomer(item);
            //         },
            //       },
            //     ],
            //   },
            // },
          ]}
        />
      ),
    },
  ];

  return (
    <>
      <DataGrid items={props.roleList} columns={columns} />
    </>
  );
};

export default AppCustomerUserRoleDetailList;
